import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Modal, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LuPhoneCall } from "react-icons/lu";
import { FiMail } from "react-icons/fi";
import { TfiWorld } from "react-icons/tfi";
import { FaYoutube, FaFacebookF, FaInstagram } from "react-icons/fa";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { baseURL } from "../services/apiEndPoint";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();
 
  const [message, setMessage] = useState("");
  const [showFaq, setShowFaq] = useState(false);

const INITIAL_TOTAL_VISITORS = 150000;

const [userData, setUserData] = useState({
  totalVisitors: INITIAL_TOTAL_VISITORS,
  todayVisitors: 1,
});

useEffect(() => {
  const today = new Date().toISOString().split("T")[0];

  let totalVisitors = parseInt(
    localStorage.getItem("totalVisitors") || INITIAL_TOTAL_VISITORS,
    10
  );

  let todayVisitors = parseInt(
    localStorage.getItem("todayVisitors") || 0,
    10
  );

  const savedDate = localStorage.getItem("visitorDate");

  // New day => reset today's counter
  if (savedDate !== today) {
    todayVisitors = 0;
    localStorage.setItem("visitorDate", today);
  }

  // Every refresh = new visit
  totalVisitors += 1;
  todayVisitors += 1;

  localStorage.setItem("totalVisitors", totalVisitors);
  localStorage.setItem("todayVisitors", todayVisitors);

  setUserData({
    totalVisitors,
    todayVisitors,
  });
}, []);

  // Subscribe form handler
  const handleSubscribe = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "7256f4cc-b435-4708-8609-97ec0ab0074d");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(Object.fromEntries(formData)),
    }).then((res) => res.json());

    if (res.success) {
      setMessage("🎉 You have successfully subscribed!");
      event.target.reset();
      setTimeout(() => setMessage(""), 3000);
    } else {
      setMessage("❌ Something went wrong. Please try again.");
    }
  };

  const quickLinks = [
    { name: t("Home"), path: "/" },
    { name: t("About"), path: "/about" },
    { name: t("Annual_Report"), path: "/annual" },
    { name: t("Certification"), path: "/certificate" },
    { name: t("Term_condi__heading1"), path: "/terms" },
  ];

  const otherLinks = [
    { name: t("Gallery"), path: "/gallery" },
    { name: t("Events"), path: "/event" },
    { name: t("Media"), path: "/media" },
    { name: t("Contact_us"), path: "/contact" },
    { name: t("Privacy_Policy"), path: "/privacy" },
  ];

  const faqData = [
    { question: t("question_FAQ1"), answer: t("answer_FAQ1") },
    { question: t("question_FAQ2"), answer: t("answer_FAQ2") },
    { question: t("question_FAQ3"), answer: t("answer_FAQ3") },
    { 
      question: t("question_FAQ4"), 
      answer: t("answer_FAQ4"),
      details: t("details_FAQ4", { returnObjects: true })
    },
    { 
      question: t("question_FAQ5"), 
      answer: t("answer_FAQ5"),
      details: t("details_FAQ5", { returnObjects: true })
    },
    { question: t("question_FAQ6"), answer: t("answer_FAQ6") },
    { question: t("question_FAQ7"), answer: t("answer_FAQ7") },
    { 
      question: t("question_FAQ8"), 
      answer: t("answer_FAQ8"),
      details: t("details_FAQ8", { returnObjects: true })
    },
  ];

  const todayVisitors = userData?.todayVisitors?.toString().split("")?.map(Number);
  const totalVisitors = userData?.totalVisitors?.toString().split("")?.map(Number);

  return (
    <footer className="footer">
      <Container>
        {/* Main Footer Content */}
        <Row className="footer-main">
          {/* Quick Links Column */}
          <Col lg={3} md={6} sm={12} className="footer-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path}>{link.name}</Link>
                </li>
              ))}
              <li>
                <span className="faq-link" onClick={() => setShowFaq(true)}>
                  {t("FAQs")}
                </span>
              </li>
            </ul>
          </Col>

          {/* Other Links Column */}
          <Col lg={3} md={6} sm={12} className="footer-col">
            <h4 className="footer-title">Resources</h4>
            <ul className="footer-links">
              {otherLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact Column */}
          <Col lg={3} md={6} sm={12} className="footer-col">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="contact-info">
              <li>
                <LuPhoneCall className="contact-icon" />
                <span>+91-9319965799</span>
              </li>
              <li>
                <FiMail className="contact-icon" />
                <span>Lssftrust@gmail.com</span>
              </li>
              <li>
                <TfiWorld className="contact-icon" />
                <span>www.lsstrust.org.in</span>
              </li>
            </ul>
          </Col>

          {/* Newsletter Column */}
          <Col lg={3} md={6} sm={12} className="footer-col">
            <h4 className="footer-title">Newsletter</h4>
            <p className="newsletter-text">Subscribe to get updates about our work</p>
            <Form onSubmit={handleSubscribe} className="newsletter-form">
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                required
              />
              <Button type="submit" className="subscribe-btn">
                Subscribe
              </Button>
            </Form>
            {message && (
              <div className={`subscribe-message ${message.includes("successfully") ? "success" : "error"}`}>
                {message}
              </div>
            )}

            {/* Social Links */}
            <div className="social-section">
              <h5 className="social-title">Follow Us</h5>
              <div className="social-links">
                <a href="https://youtube.com/@lssftrust" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
                  <FaYoutube />
                </a>
                <a href="https://www.facebook.com/lssftrust" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                  <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/lssf_trust" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </Col>
        </Row>

        {/* Visitor Stats */}
        <Row className="stats-row">
          <Col md={6}>
            <div className="stat-box">
              <span className="stat-label-footer">Total Visitors</span>
              <div className="stat-digits">
                {totalVisitors?.map((digit, idx) => (
                  <span key={idx} className="digit">{digit}</span>
                ))}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="stat-box">
              <span className="stat-label-footer">Today's Visitors</span>
              <div className="stat-digits">
                {todayVisitors?.map((digit, idx) => (
                  <span key={idx} className="digit">{digit}</span>
                ))}
              </div>
            </div>
          </Col>
        </Row>

        {/* Copyright */}
        <Row className="copyright-row">
          <Col md={6} className="text-md-start text-center">
            <p>© 2026 All rights reserved.</p>
          </Col>
          <Col md={6} className="text-md-end text-center">
            <p>
              Developed And Managed By{" "}
              <a href="https://arvmultimedia.com/" target="_blank" rel="noopener noreferrer" className="developer-link">
                The Marketing Solutions
              </a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* FAQ Modal */}
      <Modal show={showFaq} onHide={() => setShowFaq(false)} size="lg" centered className="faq-modal">
        <Modal.Header closeButton>
          <Modal.Title className="faq-modal-title">LSSF TRUST : {t("heading_FAQ")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0">
            {faqData.map((faq, idx) => (
              <Accordion.Item eventKey={idx.toString()} key={idx}>
                <Accordion.Header>{faq.question}</Accordion.Header>
                <Accordion.Body>
                  {faq.answer}
                  {faq.details && (
                    <ul className="faq-details">
                      {faq.details.map((detail, i) => (
                        <li key={i}>{detail}</li>
                      ))}
                    </ul>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Modal.Body>
      </Modal>
    </footer>
  );
};

export default Footer;